import { ActionTypes } from './actionTypes';
import { AppDispatch } from '../store';
import { createAction } from '../actions';
import { ILoginResponse } from '../../../libraries/login';

export const login = (body: ILoginResponse) => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.LOGGED_IN, body));
};

export const clearLogginIn = () => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.LOGGED_IN_CLEAR));
};

export const logout = () => (dispatch: AppDispatch) => {
  dispatch(createAction(ActionTypes.LOGOUT));
};
